import { render, staticRenderFns } from "./NewSpecificationTable.vue?vue&type=template&id=a55e4ace&scoped=true"
import script from "./NewSpecificationTable.vue?vue&type=script&lang=js"
export * from "./NewSpecificationTable.vue?vue&type=script&lang=js"
import style0 from "./NewSpecificationTable.vue?vue&type=style&index=0&id=a55e4ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55e4ace",
  null
  
)

export default component.exports